import { BseDto, SeDto } from "../../autogen/bff-api";

export const eventIsClosed = (event: BseDto | SeDto): boolean => {
  return event.status === "Closed";
};
